import history from 'history.js';
import {setDefaultSettings} from 'store/actions/fuse';
import {FuseDefaultSettings} from '@fuse';
import _ from 'lodash';
import Utils from 'yeffect/utils';

export const SET_USER_DATA = '[USER] SET DATA';
export const REMOVE_USER_DATA = '[USER] REMOVE DATA';
export const USER_LOGGED_OUT = '[USER] LOGGED OUT';

export function setUserData(user, doNotUpdate)
{
    return (dispatch) => {

        !doNotUpdate && user.role !== 'guest' && updateUserData(user);

        dispatch(setDefaultSettings(user.data.settings));

        dispatch({
            type   : SET_USER_DATA,
            payload: user
        })
    }
}

export function setUserDataFromDB(user, doNotUpdate)
{

  var payload = {
    data: {
      'displayName': user.userFirstName + ' ' + user.userLastName,
      'photoURL'   : 'assets/images/avatars/profile.jpg',
      'email'      : user.email,
      'ident'      : user.id,
      'id_number'  : user.id_number,
      shortcuts    : Utils.populateFooter(user.permissions),
      settings:{}
    },
    role: user.permissions.split(":")
  }


  return (dispatch) => {

    !doNotUpdate && payload.role !== 'guest' && updateUserData(user);

    dispatch(setDefaultSettings(payload.data.settings));

    dispatch({
      type   : SET_USER_DATA,
      payload: payload
    })
  }
}

export function updateUserSettings(settings)
{
    return (dispatch, getState) => {
        const oldUser = getState().auth.user;
        const user = _.merge({}, oldUser, {data: {settings}});
        return dispatch(setUserData(user));
    }
}



export function toggleInShortcuts(id)
{
    return (dispatch, getState) => {
        let user = getState().auth.user;
        let shortcuts = user.data.shortcuts;
        shortcuts = shortcuts.includes(id) ? shortcuts.filter(_id => id !== _id) : [...shortcuts, id];
        return dispatch(setUserData(
            {
                ...user,
                data: {
                    ...user.data,
                    shortcuts
                }
            }
        ));
    }
}

export function removeUserData()
{
    return {
        type: REMOVE_USER_DATA
    }
}

export function logoutUser()
{
    history.push({
        pathname: '/'
    });

    return (dispatch, getState) => {
        // eslint-disable-next-line
        const user = getState().auth.user;

        dispatch(setDefaultSettings(FuseDefaultSettings));

        dispatch({
            type: USER_LOGGED_OUT
        })
    }
}

function updateUserData(user)
{
    switch ( user.from )
    {
        default:
        {

        }
    }
}



// WEBPACK FOOTER //
// ./src/auth/store/actions/user.actions.js